import { InjectionToken } from '@angular/core';
import { EnvironmentConfig } from '../model/environment.model';

export const ENV_CONFIG: InjectionToken<EnvironmentConfig> = new InjectionToken<EnvironmentConfig>('environment');
